// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UWuw","right":"styles_right__2Sgfy"};